<template>

      <div class="accessIndex">
        <div class="accessIndex__general_info">
          <div class="accessIndex__reload">
            <v-hover>
              <div  @click="getClients()" slot-scope="{ hover }" class="accessIndex__reload--container" :class="hover?'accessIndex__interaction--hover':''"  >
                <img src="../../../../assets/img/reload_blue.svg">
              </div>
            </v-hover>
            <p class="accessIndex__text--title" >Usuarios de {{myName}} </p>

          </div>
          <div  class="user__container--search">
            <v-text-field

              v-model="options_table.search"
              append-icon="search"
              label="Buscar .."
              single-line
              hide-details
            ></v-text-field>
        </div>
      </div>
        <div >
          <v-spacer></v-spacer>


        </div>
        <v-data-table
          v-model="users"
          :headers="options_table.headers_table"
          :items="filteredUsers"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">
            <tr >

              <th
                v-for="header in options_table.headers_table"
                :key="header.text"
              >
                <div v-if="options_table.filters.hasOwnProperty(header.value)">
                  <v-select v-if="columnValueList(header.value)[0]!=null" flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="options_table.filters[header.value]" :placeholder="header.text">
                  </v-select>
                </div>
              </th>
            </tr>
            <tr>

              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr >

              <td class="text-xs-center">{{ props.item.name }}</td>
              <td class="text-xs-center email">{{ props.item.email }}</td>
              <td class="text-xs-center">{{ props.item.mobile }}</td>
              <td class="text-xs-center">{{ props.item.gender }}</td>
              <td class="text-xs-center">{{ props.item.age }}</td>
              <td class="text-xs-center">{{ props.item.access_state }}</td>


            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>




    </div>


</template>

<script>
export default {
  data(){
    return{
      selected: 'Todos los usuarios',
      notification_selector: ['Todos los usuarios', 'Varios usuarios'],
      notification: {
        attributes: {
          title: '',
          message: '',
          users: [],
          send_date_time: '',
          gmt: ''
        }
      },
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Usuario',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Email',
            align: 'center',
            value: 'email'
          },

          {
            text: 'Celular',
            align: 'center',
            value: 'mobile'
          },
          {
            text: 'Género',
            align: 'center',
            value: 'gender'
          },
          {
            text: 'Edad',
            align: 'center',
            value: 'age'
          },
          {
            text: 'Estado de acceso',
            align: 'center',
            value: 'access_state'
          }
        ],
        filters: {
          gender: [],
          age: [],
          access_state:[]
        },
      },

      users: [],
      users_for_select:[],
      right_now: true,
      rules: {
          required: value => !!value || 'Required.',
          title: value => value.length <= 200 || 'Maximo 45 caracteres',
          message: value => value.length <= 250 || 'Maximo 90 caracteres',
      },
      valid: false
    }
  },
  mounted() {
    this.getClients();
  },
  computed: {
    filteredUsers() {
      return this.users_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    },
    myName(){
      return localStorage.getItem("location_name")
    }
  },
  methods: {
    toggleAll () {
      var vm = this;
      var emails = document.querySelectorAll("table.v-datatable td.email");
      var check = document.querySelector(".v-table thead [aria-checked]").getAttribute("aria-checked");
      if (check=="false") {
        emails.forEach(function(element) {
          vm.users.splice(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML )),1);
        });
      }else{
        emails.forEach(function(element) {
          if(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML ))==-1){
            vm.users.push(vm.filteredUsers.find( user => user.email === element.innerHTML ));
          }
        });
      }
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    columnValueList(val) {
      return this.users_for_select.map(d => d[val])
    },
    getClients(){
      var self=this;
      try {
        this.$http.get('app/users/clients',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{location_id:localStorage.getItem("location_id")}}
         ).then(function(response){
           this.users_for_select = response.body.data;
           if(response.body.meta != undefined && response.body.meta != null){
             if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
               this.checkToken(response.body.meta.authentication_token)
             }
           }
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){            
            if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
              self.updateAlertMessage(response.body.errors[0].details)
              self.updateIsInAlert(true)
            }else{
              alert(response.body.errors[0].details)
            }
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
              self.updateAlertMessage(message)
              self.updateIsInAlert(true)
            }else{
              alert(message)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
          self.updateAlertMessage(e.message)
          self.updateIsInAlert(true)
        }else{
          alert(e.message)
        }
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        };
      }
    }



  }

}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/CounterUserIndex.vue